import angular from 'angular';
import service from './myAlerts.service';
import NgUser from 'cars-ng-user';
import NgBrowser from 'cars-ng-browser';

import Config from '../../config/index';
import component from './myAlerts.component';

export default angular.module('cars.enhanced.vdp.myAlerts', [
    Config,
    NgUser,
    NgBrowser,
    'cars.enhanced.vdp.vdpSaveVehicle'
])
.component('carsMyAlertsModal', component)
.factory('myAlertsService', service)
.name;
